import { useState } from "react";
import { Typewriter } from "react-simple-typewriter";
import { books } from "./BookData";

function Header() {
  const [done, setDone] = useState(false);
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [modalImage, setModalImage] = useState(null);

  const toggleDescription = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <main className="flex flex-col items-center justify-center px-4 sm:mt-28 mt-20 font-bembo text-lg">
      <h1 className="mx-auto max-w-4xl font-display text-5xl font-bold tracking-normal text-slate-900 sm:text-7xl text-center mb-10">
        {done ? (
          "LIBROS"
        ) : (
          <Typewriter
            words={["LIBROS"]}
            loop={1}
            cursor
            cursorStyle="|"
            typeSpeed={80}
            deleteSpeed={40}
            delaySpeed={1000}
            onLoopDone={() => setDone(true)}
          />
        )}
      </h1>
      <h3 className="mx-auto max-w-1xl font-display text-2xl font-bold tracking-normal text-slate-900 sm:text-4xl">
        Recomendaciones de Libros
      </h3>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-8 w-full max-w-7xl">
        {books.map((book, index) => (
          <div
            key={index}
            className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300 p-4 flex flex-col items-center"
          >
            <img
              src={book.image}
              alt={book.title}
              className="w-full h-64 object-cover rounded-xl mb-4 cursor-pointer"
              onClick={() => setModalImage(book.image)}
            />
            <h2 className="text-xl font-semibold text-slate-800 text-center mb-2">
              {book.title}
            </h2>
            <p className="text-slate-600 text-md text-justify">
              {expandedIndex === index
                ? book.description
                : book.description.length > 200
                ? book.description.slice(0, 200) + "..."
                : book.description}
            </p>
            {book.description.length > 200 && (
              <button
                type="button"
                onClick={() => toggleDescription(index)}
                className="mt-2 text-gray-600 hover:underline text-md"
              >
                {expandedIndex === index ? "Leer menos" : "Leer más"}
              </button>
            )}
          </div>
        ))}
      </div>

      {/* Modal overlay for image zoom */}
      {modalImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-70 backdrop-blur-sm flex items-center justify-center z-50"
          onClick={() => setModalImage(null)}
        >
          <img
            src={modalImage}
            alt="Vista ampliada"
            className="max-w-[90%] max-h-[90%] rounded-xl border-4 border-white shadow-2xl"
          />
        </div>
      )}
      <br />
      <br />
      <br />
    </main>
  );
}

export default Header;
